import { ORDER_TYPE_CACHE, SHOPPING_CART_CACHE, USER_ADDRESS_CACHE } from '../model/caches';

export function clearCachedData() {
  caches.delete(ORDER_TYPE_CACHE);
  caches.delete(SHOPPING_CART_CACHE);
  caches.delete(USER_ADDRESS_CACHE);
}
